export const SUPER_ADMIN = 'SUPER_ADMIN';
export const STRUCTURE = 'STRUCTURE';
export const SUBSCRIBER = 'SUBSCRIBER';
export const EMPLOYER = 'EMPLOYER';
export const CUSTOMER = 'CUSTOMER';

